import styled, { css } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint, mobileBreakpoint, wideScreenBreakpoint } from 'react-components'
import { CarouselProvider, Slider } from 'pure-react-carousel'

export const Container = styled.section`
    padding: 0.5rem 0;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 2rem 0.5rem 1rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 2rem 3rem 1.5rem;
    }
`

export const TitleContainer = styled.div`
    padding-left: 1rem;

    @media only screen and (min-width: 1024px) and (max-width: 1280px) {
        padding: 0 1rem;
    }

    @media only screen and (min-width: ${tabletBreakpoint.min}px) and (max-width: ${tabletBreakpoint.max}px) {
        padding: 0 1.5rem;
    }

    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        padding: 0.5rem 1rem 0;
    }
`

export const ListContainer = styled.div`
    padding: 0 0 1rem;
    position: relative;

    @media (max-width: ${mobileBreakpoint.max}px) {
        padding-left: 1rem;
    }

    @media (min-width: ${tabletBreakpoint.min}px) and (max-width: ${tabletBreakpoint.max}px) {
        padding: 0 0 0 1.5rem;
    }

    @media (min-width: ${desktopBreakpoint.min}px) {
        padding: 0 1rem 1rem;
    }

    @media (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 0 0 0 1rem;
    }
`

export const Cell = styled.a`
    flex: 0 0 auto;
    text-decoration: none !important;
    color: inherit;
`

export const Item = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    color: inherit;
    transition: transform 0.2s ease;
    flex: 0 0 auto;
    gap: 1rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) and (max-width: ${tabletBreakpoint.max}px) {
        min-width: 7rem;
        min-height: 9.4rem;
    }

    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        min-width: 4.5rem;
        min-height: 5.75rem;
        gap: 0.25rem;
    }
`

export const ImageContainer = styled.div`
    border-radius: 50%;
    overflow: hidden;
    width: 100%;
    max-width: 4.5rem;
    aspect-ratio: 1;
    flex-shrink: 0;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        max-width: 8rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        max-width: 9rem;
    }
`

export const PropertyTypeImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transform: scale(1.05);
    transition: transform 0.3s ease-in-out;
    background-color: #f5f5f5;

    &:hover {
        transform: scale(1);
    }

    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        max-width: 4.5rem;
        max-height: 4.5rem;
    }
`

export const SliderContainer = styled.div`
    position: relative;
    max-width: fit-content;
    margin-top: 0.5rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin-top: 1rem;
    }
`

export const StyledCarouselProvider = styled(CarouselProvider)<{ margin?: string; center?: boolean }>`
    width: 100%;
    margin: ${({ margin }) => (!!margin ? margin : 0)};
    li {
        list-style: none;
    }
    ${({ center }) =>
        center
            ? `& > .carousel__slider {
            padding-left: 1rem;
            padding-right: 1rem;

            @media only screen and (min-width: ${tabletBreakpoint.min}px) {
                padding: 0 1.5rem;
            }
        }`
            : ''}
`

export const StyledSlider = styled(Slider)<{ $transitionTime?: number }>(
    ({ $transitionTime }) => css`
        overflow: hidden;
        padding: 0;
        ul {
            transition: transform ${$transitionTime ? `${$transitionTime}s` : `0.5s`};
            transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
            will-change: transform;
        }

        & .carousel__slider-tray.carousel__slider-tray--horizontal {
            gap: 1rem;

            @media only screen and (min-width: ${tabletBreakpoint.min}px) {
                gap: 1.5rem;
            }

            @media only screen and (min-width: ${desktopBreakpoint.min}px) {
                padding: 0;
            }
        }
    `,
)

export const Label = styled.span`
    text-align: center;
    font-weight: 700;
    font-size: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    line-height: 1.5rem;
    letter-spacing: -0.01875rem;
    text-decoration: none !important;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) and (max-width: ${tabletBreakpoint.max}px) {
        font-size: 0.875rem;
        line-height: 1.375rem;
    }

    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        font-weight: 400;
        font-size: 0.75rem;
        line-height: 1rem;
    }
`
